<div class="center-block">
  <div class="loader">
    <div class="upper ball"></div>
    <div class="right ball"></div>
    <div class="lower ball"></div>
    <div class="left ball"></div>
  </div>
</div>
